module.exports = __webpack_public_path__ + "static/6480-genesis-4ca0261234887c53627ab2eccaea0d79.png";